import { http, HttpResponse } from 'msw';

import { apiRoutes } from '@features/campaigns/builder/consts/apiRoutes';
import { mockedThematicCampaignDetails } from '@shared/mocks/requests/campaignDetails/campaignDetails.fixtures.ts';

const highImpactCreativeRoutes = [
  apiRoutes.creativeIntroMobileImage,
  apiRoutes.creativeMastheadImage,
  apiRoutes.creativeMastheadAdaptiveImage,
  apiRoutes.creativeSkinImage,
];

export const highImpactCreativesRequests = [
  http.put(`*${apiRoutes.updateHighImpactAdProduct(':id')}`, () => {
    return HttpResponse.json(mockedThematicCampaignDetails);
  }),
  ...highImpactCreativeRoutes.flatMap((route) => [
    http.post(`*${route(':id')}`, () => {
      return new HttpResponse(null, { status: 201 });
    }),
    http.delete(`*${route(':id')}`, () => {
      return HttpResponse.json();
    }),
  ]),
];
